export const actions = {
    ADD_SURVEY_ACTIVITY: 'ADD_SURVEY_ACTIVITY',
    ADD_SURVEY_SET_ACTIVITY: 'ADD_SURVEY_SET_ACTIVITY',

    ADD_SURVEY_UPDATE_ACTIVITY: 'ADD_SURVEY_UPDATE_ACTIVITY',

    DELETE_SURVEY_ACTIVITY: 'DELETE_SURVEY_ACTIVITY',
    DELETE_SURVEY_SET_ACTIVITY: 'DELETE_SURVEY_SET_ACTIVITY',

    SET_SURVEY_DATA_DEFAULT: 'SET_SURVEY_DATA_DEFAULT',

    GET_EDIT_SURVEY_INFO: 'GET_EDIT_SURVEY_INFO',

    RESPONSE_SURVEY: 'RESPONSE_SURVEY',

    GET_SELECTED_LOGIN_SURVEY: 'GET_SELECTED_LOGIN_SURVEY', 
    SET_SELECTED_LOGIN_SURVEY: 'SET_SELECTED_LOGIN_SURVEY',

    GET_SURVEY_LIST: 'GET_SURVEY_LIST',
    SET_SURVEY_LIST: 'SET_SURVEY_LIST',

    GET_SELECTED_GENERAL_SURVEY: 'GET_SELECTED_GENERAL_SURVEY', 
    SET_SELECTED_GENERAL_SURVEY: 'SET_SELECTED_GENERAL_SURVEY',
};